import React from 'react'
import PropTypes from 'prop-types'
import * as Styled from './VisitingHours.styles'

/**
 * @returns {*}
 * @constructor
 */
const VisitingHours = ({ data }) => {
  if (typeof data === 'string') {
    return <Styled.VisitingHoursComponent>{data}</Styled.VisitingHoursComponent>
  }

  const dataKeys = Object.keys(data)

  return (
    <Styled.VisitingHoursComponent>
      {dataKeys.map((key, dataIdx) => (
        <span key={ dataIdx }>
          {`${ key }: ${ data[key].map(
            (time, idx) => `${ time }${ data[key].length > idx + 1 ? ', ' : '' }`
          ) }`}
          {dataKeys.length > dataIdx + 1 ? <br /> : null}
        </span>
      ))}
    </Styled.VisitingHoursComponent>
  )
}

// TODO define data type with BE
VisitingHours.propsTypes = {
  data: PropTypes.oneOf([PropTypes.string, PropTypes.object]),
}

export default VisitingHours
